<!-- Base component for views. It performs route redirects and shows global error messages. -->

<template>
  <div>
    <slot />

    <modal v-if="apiError">
      <template slot="header">Tapahtui virhe</template>
      <template slot="body">Sivu täytyy päivittää, jonka jälkeen palvelun käyttöä voidaan jatkaa normaalisti</template>
      <template slot="footer">
        <v-button type="button" @click="reload" variant="primary">Päivitä</v-button>
      </template>
    </modal>
    <modal v-else-if="connectionError">
      <template slot="header">Yhteysongelma</template>
      <template slot="body">Verkkoyhteyden kanssa on ongelmia. Palvelun käyttöä voi jatkaa normaalisti, kun yhteysongelma on ohitse.</template>
    </modal>
  </div>
</template>

<script>

import { mapGetters } from "vuex";
import delay from "delay";

import Modal from '@/components/Modal.vue';
import router from '@/router';
import Button from '@/components/Button.vue';

export default {
  name: 'ViewBase',
  components: {
    Modal,
    'v-button': Button,
  },
  data: function () {
    return {
      connectionTimeout: false,
      connectionTimerId: 0,
    };
  },
  computed: {
    connectionError() {
      return !this.connected && !!this.profile.userId && this.connectionTimeout;
    },

    ...mapGetters({
      connected: 'connected',
      profile: 'profile',
      apiError: 'apiError',
    })
  },
  watch: {
    connected: {
      immediate: true,
      handler(value) {
        this.resetConnectionTimeout();
      },
    },
    profile: {
      immediate: true,
      handler(value) {
        const {
          userId,
          firstName,
          lastName,
          role,
        } = value;

        if (userId && (!firstName || !lastName || !role)) {
          router.push('/profile');
        }

        this.resetConnectionTimeout();
      },
    },
  },
  methods: {
    reload() {
      window.location.reload();
    },
    resetConnectionTimeout() {
      this.connectionTimeout = false;
      const timerId = ++this.connectionTimerId;

      (async () => {
        await delay(3000);

        if (timerId === this.connectionTimerId) {
          this.connectionTimeout = true;
        }
      })();
    }
  },
}

</script>

<style scoped>

</style>
